import { TrophyContainer, LayerImg } from './styled-components';

// ── Full trophy SVGs per level ──────────────────────────────────────────────
import beginnerSvg from '@/shared/icons/Gamification/beginner.svg';
import bronzeSvg from '@/shared/icons/Gamification/bronze.svg';
import silverSvg from '@/shared/icons/Gamification/silver.svg';
import goldSvg from '@/shared/icons/Gamification/gold.svg';
import platiniumSvg from '@/shared/icons/Gamification/platinium.svg';
import diamondSvg from '@/shared/icons/Gamification/diamond.svg';
import eliteSvg from '@/shared/icons/Gamification/elite.svg';

// ── Overlay icons ───────────────────────────────────────────────────────────
import IconHouse from '@/shared/icons/Gamification/IconHouse';
import IconComputer from '@/shared/icons/Gamification/IconComputer';
import IconArticle from '@/shared/icons/Gamification/IconArticle';
import IconCycle from '@/shared/icons/Gamification/IconCycle';
import IconMail from '@/shared/icons/Gamification/IconMail';
import IconMobile from '@/shared/icons/Gamification/IconMobile';
import IconTarget from '@/shared/icons/Gamification/IconTarget';
import IconPsychiatry from '@/shared/icons/Gamification/IconPsychiatry';

const LEVEL_SVGS = {
  beginner: beginnerSvg,
  bronze: bronzeSvg,
  silver: silverSvg,
  gold: goldSvg,
  platinium: platiniumSvg,
  diamond: diamondSvg,
  elite: eliteSvg,
};

const CATEGORY_OVERLAY = {
  contract:    { width: 32, height: 32, icon: IconTarget },
  axa:         { width: 28, height: 28, icon: IconHouse },
  offset:      { width: 30, height: 31, icon: IconPsychiatry },
  lead:        { width: 24, height: 24, icon: IconCycle },
  protected:   { width: 20, height: 18, icon: IconComputer },
  neat:        { width: 18, height: 18, icon: IconArticle },
  nlbp:        { width: 20, height: 16, icon: IconMail },
  myselectra:  { width: 15, height: 22, icon: IconMobile },
};

const CATEGORY_OVERLAY_COLORS = {
  starter: '#FFFFFF',
  beginner: '#E9EEFB',
  bronze: '#F1DCC0',
  silver: '#EDE9EA',
  gold: '#FFF5DF',
  platinium: '#F9F9FA',
  diamond: '#F8F8F9',
  elite: '#FEF3DB',
};

// SVG natural dimensions & hex centre for overlay positioning
const SVG_W = 110;
const SVG_H = 103;
const HEX_CX = 55;
const HEX_CY = 38;
const OVERLAY_SIZE = 24;

const TrophyBadge = ({ categoryId, trophyColor = 'empty', width = 90, dimmed = false, numberOverlay = null }) => {
  const svgSrc = LEVEL_SVGS[trophyColor];
  const OverlayIcon = CATEGORY_OVERLAY[categoryId]?.icon || null;
  const overlayColor = CATEGORY_OVERLAY_COLORS[trophyColor] || '#000';
  const overlaySizeW = CATEGORY_OVERLAY[categoryId]?.width || OVERLAY_SIZE;
  const overlaySizeH = CATEGORY_OVERLAY[categoryId]?.height || OVERLAY_SIZE;

  const scale = width / SVG_W;
  const renderedH = SVG_H * scale;

  return (
    <TrophyContainer $width={width} $height={renderedH}>
      <LayerImg
        src={svgSrc || beginnerSvg}
        alt=""
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: `${width / 16}rem`,
          height: `${renderedH / 16}rem`,
          ...(dimmed || !svgSrc ? { filter: 'grayscale(1) opacity(0.4)' } : {}),
        }}
      />
      { numberOverlay !== null && (
        <div style={{
          position: 'absolute',
          left: `${((HEX_CX - 12) * scale) / 16}rem`,
          top: `${((HEX_CY - 12) * scale) / 16}rem`,
          width: `${(24 * scale) / 16}rem`,
          height: `${(24 * scale) / 16}rem`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: `${(22 * scale) / 16}rem`,
          color: '#5C6575',
          textShadow: '0 0 2px rgba(0,0,0,0.5)',
          pointerEvents: 'none',
        }}>
          {numberOverlay}
        </div>
       )
      }
      {OverlayIcon && (
        <OverlayIcon
          color={overlayColor}
          alt=""
          style={{
            position: 'absolute',
            left: `${((HEX_CX - overlaySizeW / 2) * scale) / 16}rem`,
            top: `${((HEX_CY - overlaySizeH / 2) * scale) / 16}rem`,
            width: `${(overlaySizeW * scale) / 16}rem`,
            height: `${(overlaySizeH * scale) / 16}rem`,
            pointerEvents: 'none',
          }}
        />
      )}
    </TrophyContainer>
  );
};

export default TrophyBadge;
